module.exports = __webpack_public_path__ + "static/colgadas-010.thumb-44eda5be560b35117bc594b3743df899.jpg";